<template>
  <div>
    <v-autocomplete
      clearable
      :label="$t('ticketActions.transfer.label')"
      :items="dataUsers"
      v-model="userId"
      item-text="name"
      item-value="id"
      variant="solo-inverted"
      :loading="loading"
      @change="handleChange"
      >
    </v-autocomplete>

    <v-textarea
      class="mt-4"
      outlined
      hide-details="auto"
      v-model="commentTransfer"
      :auto-grow="true"
      :no-resize="!$vuetify.breakpoint.mdAndUp"
      rows="3"
      :autofocus="true"
      :disabled="submitting"
      :placeholder="$t('ticketActions.cancel.placeholder')"
    />

    <div class="d-flex flex-wrap justify-end">
      <v-btn
        class="mt-4 btn__default"
        @click="send"
        :block="!$vuetify.breakpoint.mdAndUp"
        :class="{ 'btn__disabled': !selectedUserBtn }"
      >
        {{ $t("commons.accept") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
// eslint-disable-next-line import/no-cycle
import { TRANSFER } from './index';

export default {
  props: {
    ticket: {
      type: Object,
      required: true,
    },
    user: Object,
  },
  data() {
    return {
      dataUsers: [],
      search: '',
      userId: '',
      selectedUserBtn: false,
      submitting: false,
      loading: false,
      commentTransfer: '',
    };
  },
  computed: {
    title: () => TRANSFER.key,
    icon: () => TRANSFER.icon,
  },
  methods: {
    handleChange(userIDSelected) {
      this.userId = userIDSelected;
      this.selectedUserBtn = true;
    },
    async send() {
      this.submitting = true;
      const messageId = await this.$store.dispatch(
        'messages/createNotificationMessage',
        {
          icon: 'progress-circular',
          title: this.$t('ticketActions.messages.creating'),
        },
      );

      try {
        const idTicket = this.ticket.id;
        const idAssign = this.ticket.assignee.id;
        const idNextAssign = this.userId;
        const idTagApp = this.$getConst('tagActivity.transfer.idTagApp');
        const idTagWeb = this.$getConst('tagActivity.transfer.idTagWeb');
        const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
        const tagActivity = isMobile ? idTagApp : idTagWeb;

        const response = await this.client.transferActivity({
          idTicket,
          idAssign,
          idNextAssign,
          commentTransfer: this.commentTransfer,
          tagActivity,
        });

        this.$emit('update:detail', ({ activities }) => {
          const ticket = response.total ? response.unique() : null;
          return {
            activities: activities
              .concat(ticket != null ? ticket.activities : [])
              .sort((d1, d2) => (moment(d2.date).isSameOrAfter(d1.date) ? 1 : -1)),
          };
        });

        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'success',
          icon: 'mdi-check-circle',
          title: this.$t('ticketActions.messages.success'),
          timeout: this.$getConst('notifications.timeout'),
        });
        this.$emit('input');
        this.$emit('refresh:detail');
        this.submitting = false;
        await this.$store.dispatch('tickets/listApprovals', {});
        this.$router.push('/approvals');
      } catch (ex) {
        console.error('error on ticket upgrade submit', ex);

        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'error',
          icon: 'mdi-close-circle',
          title: this.$t('ticketActions.messages.error'),
          timeout: this.$getConst('notifications.timeout'),
        });
        this.submitting = false;
      }
    },
  },
  async created() {
    this.client = this.$api.getClient('ticket');
    this.loading = true;
    const response = await this.client.getUsersforTranfers(this.ticket);
    const { data } = response;
    this.dataUsers = data.collection_users.users;
    this.loading = false;
  },
};
</script>

<style>
.container__input {
  height: 3.7rem;
}
.container__user {
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14),
    0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  text-transform: uppercase;
  padding: 6px 0;
}
.input__name {
  padding: 6px 16px;
  margin: 0 !important;
  cursor: pointer;
}
.input__name--else {
  padding: 6px 16px;
  margin: 0 !important;
  text-transform: initial;
}
.input__name:hover {
  background-color: #f6f6f6;
}
.container__input .v-input__control {
  height: 0rem;
}
.btn__default {
  background-color: #27846d !important;
  border-color: #27846d !important;
  color: #fff !important;
}
.btn__disabled {
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
